import { UpdateControlMetadata } from '../validators/helpers';
import { MemoizedSelector } from '@ngrx/store';

export function FxHide(selector?: MemoizedSelector<any, boolean>) {
  return function (target: any, propertyKey: string) {
    if (selector) {
      UpdateControlMetadata(target, propertyKey, { fxHideSelector: selector });
    } else {
      UpdateControlMetadata(target, propertyKey, { fxHide: true });
    }
  }
}
